import { Tabs, Tab, type TabId, Button } from "@blueprintjs/core";
import { TABS } from "../../../utils";
import { Box, CustomButton } from "ui-components";
import styled from "styled-components";
import { openPricingDialog } from "ui-io/stores/pricing-store";

import "./styles.css";
import PricingPage from "../../../pages/pricing";
interface SidebarProps {
  tabValue: TabId;
  handleTabChange: (newValue: string) => void;
}

const Sidebar: React.FC<SidebarProps> = ({ tabValue, handleTabChange }) => {
  return (
    <SidebarContainer>
      <Logo>
        <img src="/images/logo.svg" alt="Logo" />
      </Logo>
      <Tabs
        id={"sidebar-tabs"}
        defaultSelectedTabId={TABS.DASHBOARD}
        selectedTabId={tabValue}
        className={"sidebar-tab"}
        vertical={true}
        onChange={handleTabChange}
        renderActiveTabPanelOnly={true}
        large={true}
      >
        <Tab
          title={<GetTabLabel title="Dashboard" />}
          icon={dashboardSVG}
          id={TABS.DASHBOARD}
          className={`tab-style ${tabValue === TABS.DASHBOARD && "selected-tab-style"}`}
        />

        <Tab
          title={<GetTabLabel title="Funding Rounds" />}
          icon={fundingRounds}
          id={TABS.FUNDING_ROUNDS}
          className={`tab-style ${tabValue === TABS.FUNDING_ROUNDS && "selected-tab-style"}`}
        />
        <Tab
          title={<GetTabLabel title="Signal" />}
          icon={signal}
          id={TABS.SIGNAL}
          className={`tab-style ${tabValue === TABS.SIGNAL && "selected-tab-style"}`}
        />
        {/* <Tab
          title={<GetTabLabel title="Investment Trends" />}
          icon={investmentTrendsSvg}
          id={TABS.INVESTMENT_TRENDS}
          className={`tab-style ${tabValue === TABS.INVESTMENT_TRENDS && "selected-tab-style"}`}
        /> */}
        <Tab
          title={<GetTabLabel title="Investors" />}
          icon={investorsSvg}
          id={TABS.INVESTORS}
          className={`tab-style ${tabValue === TABS.INVESTORS && "selected-tab-style"}`}
        />
        <Tab
          title={<GetTabLabel title="Unicorns" />}
          icon={unicornsSvg}
          id={TABS.UNICORNS}
          className={`tab-style ${tabValue === TABS.UNICORNS && "selected-tab-style"}`}
        />
        <Tab
          title={<GetTabLabel title="People" />}
          icon={peopleSvg}
          id={TABS.PEOPLE}
          className={`tab-style ${tabValue === TABS.PEOPLE && "selected-tab-style"}`}
        />
        <Tab
          title={<GetTabLabel title="Profile" />}
          icon={profileSvg}
          id={TABS.PROFILE}
          className={`tab-style ${tabValue === TABS.PROFILE && "selected-tab-style"}`}
        />
      </Tabs>

      <PremiumButton />
    </SidebarContainer>
  );
};

export default Sidebar;

const SidebarContainer = styled.div`
  width: 250px;
  background-color: #111111;
  color: white;
  height: 100vh;
  padding: 20px 0px;
  display: flex;
  flex-direction: column;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.25);
  @media (min-width: 1251px) and (max-width: 1380px) {
    width: 225px;
  }
  @media (min-width: 993px) and (max-width: 1250px) {
    width: 200px;
  }
  @media (min-width: 769px) and (max-width: 992px) {
    width: 180px;
  }
`;

const Logo = styled.div`
  margin: 10px auto;
`;
const PremiumContainer = styled.div`
  width: 90%;
  margin: auto;
  background-color: #d3d3d3;
  border-radius: 10px;
  padding: 20px 40px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: center;
  p {
    font-size: 17px;
    font-weight: bold;
    margin-bottom: 20px;
    color: black; /* text color */
    text-align: left;
    line-height: 1.3em;
  }
  button {
    background-color: black; /* button background color */
    color: white; /* button text color */
    font-size: 16px;
    padding: 10px 20px;
    border: none;
    border-radius: 20px;
    cursor: pointer;
    &:hover {
      background-color: #555;
    }
  }
  @media (max-width: 1380px) {
    padding: 20px 30px;
  }
  @media (max-width: 1280px) {
    button {
      font-size: 13px !important;
    }
    p {
      font-size: 14px !important;
    }
  }
`;

interface GetTabLabelProps {
  title?: string;
}

export const GetTabLabel: React.FC<GetTabLabelProps> = ({ title = "" }) => {
  return (
    <Box ml={"small"}>
      <div>{title}</div>
    </Box>
  );
};

function PremiumButton() {
  return (
    <PremiumContainer>
      <p>Unlock Premium Features</p>
      <CustomButton onClick={openPricingDialog} pd="5px 15px">
        Upgrade Now
      </CustomButton>
      <PricingPage />
    </PremiumContainer>
  );
}

export const dashboardSVG = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2 10.5H4.5H7.5C7.53204 10.5 7.56603 10.5003 7.60035 10.5006C7.68554 10.5012 7.77275 10.502 7.837 10.4985L7.83934 10.4984C7.91494 10.4943 8.13717 10.4824 8.3098 10.3098C8.48244 10.1372 8.49433 9.91493 8.49837 9.83934L8.4985 9.837C8.50195 9.77275 8.50125 9.68554 8.50055 9.60034C8.50028 9.56603 8.5 9.53203 8.5 9.5V6.5V2.5C8.5 2.46527 8.50027 2.42768 8.50055 2.38865C8.50123 2.2926 8.50197 2.18782 8.49895 2.09539C8.49462 1.96273 8.48209 1.80121 8.43378 1.64555C8.38271 1.48099 8.28436 1.30032 8.09659 1.16908C7.91372 1.04127 7.70247 1 7.5 1H2C1.17386 1 0.5 1.67386 0.5 2.5V9.5C0.5 9.70247 0.541269 9.91372 0.669083 10.0966C0.800319 10.2844 0.980986 10.3827 1.14555 10.4338C1.30121 10.4821 1.46273 10.4946 1.59539 10.499C1.68782 10.502 1.7926 10.5012 1.88865 10.5005C1.92768 10.5003 1.96527 10.5 2 10.5ZM2 20H7.5C7.70247 20 7.91372 19.9587 8.09659 19.8309C8.28436 19.6997 8.38271 19.519 8.43378 19.3544C8.48209 19.1988 8.49462 19.0373 8.49895 18.9046C8.50197 18.8122 8.50123 18.7074 8.50055 18.6114C8.50027 18.5723 8.5 18.5347 8.5 18.5V14.5C8.5 14.4653 8.50027 14.4277 8.50055 14.3886C8.50123 14.2926 8.50197 14.1878 8.49895 14.0954C8.49462 13.9627 8.48209 13.8012 8.43378 13.6456C8.38271 13.481 8.28436 13.3003 8.09659 13.1691C7.91372 13.0413 7.70247 13 7.5 13H2C1.17386 13 0.5 13.6739 0.5 14.5V18.5C0.5 19.3261 1.17386 20 2 20ZM12 20H18C18.8261 20 19.5 19.3261 19.5 18.5V11C19.5 10.7975 19.4587 10.5863 19.3309 10.4034C19.1997 10.2156 19.019 10.1173 18.8544 10.0662C18.6988 10.0179 18.5373 10.0054 18.4046 10.001C18.3122 9.99803 18.2074 9.99877 18.1114 9.99946C18.0723 9.99973 18.0347 10 18 10H15H12C11.968 10 11.934 9.99972 11.8997 9.99945C11.8145 9.99875 11.7273 9.99805 11.663 10.0015L11.6607 10.0016C11.5851 10.0057 11.3628 10.0176 11.1902 10.1902C11.0176 10.3628 11.0057 10.5851 11.0016 10.6607L11.0015 10.663C10.998 10.7273 10.9988 10.8145 10.9994 10.8997C10.9997 10.934 11 10.968 11 11V14.5V18.5C11 18.5137 11 18.5276 11 18.542C10.9996 18.7811 10.9992 19.1063 11.0898 19.3692C11.1441 19.5268 11.2415 19.6989 11.4182 19.8264C11.5951 19.9542 11.7997 20 12 20ZM11 2.5V6.5C11 6.53204 10.9997 6.56603 10.9994 6.60035C10.9988 6.68554 10.998 6.77275 11.0015 6.837L11.0016 6.83934C11.0057 6.91494 11.0176 7.13717 11.1902 7.3098C11.3628 7.48244 11.5851 7.49433 11.6607 7.49837L11.663 7.4985C11.7273 7.50195 11.8145 7.50125 11.8997 7.50055C11.934 7.50028 11.968 7.5 12 7.5H18C18.0347 7.5 18.0723 7.50027 18.1114 7.50055C18.2074 7.50123 18.3122 7.50197 18.4046 7.49895C18.5373 7.49462 18.6988 7.48209 18.8544 7.43378C19.019 7.38271 19.1997 7.28436 19.3309 7.09659C19.4587 6.91372 19.5 6.70247 19.5 6.5V2.5C19.5 1.67386 18.8261 1 18 1H12C11.7975 1 11.5863 1.04127 11.4034 1.16908C11.2156 1.30032 11.1173 1.48099 11.0662 1.64555C11.0179 1.80121 11.0054 1.96273 11.001 2.09539C10.998 2.18782 10.9988 2.2926 10.9995 2.38865C10.9997 2.42768 11 2.46527 11 2.5Z" />
  </svg>
);

export const fundingRounds = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    stroke="currentColor"
    fill="currentColor"
    strokeWidth="0"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.0008 6.9C11.492 6.9 12.7008 5.69117 12.7008 4.2C12.7008 2.70883 11.492 1.5 10.0008 1.5C8.50961 1.5 7.30078 2.70883 7.30078 4.2C7.30078 5.69117 8.50961 6.9 10.0008 6.9Z" />
    <path d="M9.99922 19.5004C10.9933 19.5004 11.7992 18.6945 11.7992 17.7004C11.7992 16.7063 10.9933 15.9004 9.99922 15.9004C9.00511 15.9004 8.19922 16.7063 8.19922 17.7004C8.19922 18.6945 9.00511 19.5004 9.99922 19.5004Z" />
    <path d="M17.1984 19.5004C18.1925 19.5004 18.9984 18.6945 18.9984 17.7004C18.9984 16.7063 18.1925 15.9004 17.1984 15.9004C16.2043 15.9004 15.3984 16.7063 15.3984 17.7004C15.3984 18.6945 16.2043 19.5004 17.1984 19.5004Z" />
    <path d="M2.8 19.5004C3.79411 19.5004 4.6 18.6945 4.6 17.7004C4.6 16.7063 3.79411 15.9004 2.8 15.9004C1.80589 15.9004 1 16.7063 1 17.7004C1 18.6945 1.80589 19.5004 2.8 19.5004Z" />
    <path d="M17.2008 13.1996C17.2008 12.2051 16.1928 11.3996 14.9508 11.3996H5.05078C3.80878 11.3996 2.80078 12.2051 2.80078 13.1996M10.0008 9.59961V13.1996" />
  </svg>
);
export const signal = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    stroke="currentColor"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8.098 11.1524C7.74968 10.8042 7.47336 10.3908 7.28485 9.93574C7.09633 9.4807 6.9993 8.99299 6.9993 8.50045C6.9993 8.00791 7.09633 7.52019 7.28485 7.06515C7.47336 6.61012 7.74968 6.19668 8.098 5.84844M13.402 5.84844C13.7503 6.19668 14.0266 6.61012 14.2152 7.06515C14.4037 7.52019 14.5007 8.00791 14.5007 8.50045C14.5007 8.99299 14.4037 9.4807 14.2152 9.93574C14.0266 10.3908 13.7503 10.8042 13.402 11.1524M5.977 13.2734C5.3502 12.6466 4.85299 11.9025 4.51376 11.0836C4.17454 10.2646 3.99994 9.38687 3.99994 8.50045C3.99994 7.61402 4.17454 6.73627 4.51376 5.91731C4.85299 5.09836 5.3502 4.35424 5.977 3.72745M15.523 3.72745C16.1498 4.35424 16.647 5.09836 16.9862 5.91731C17.3255 6.73627 17.5001 7.61402 17.5001 8.50045C17.5001 9.38687 17.3255 10.2646 16.9862 11.0836C16.647 11.9025 16.1498 12.6466 15.523 13.2734M3.856 15.3944C0.0479999 11.5874 0.0479999 5.41445 3.856 1.60645M17.644 1.60645C21.452 5.41345 21.452 11.5864 17.644 15.3944M10.75 8.50045H10.758V8.50845H10.75V8.50045ZM11.125 8.50045C11.125 8.5999 11.0855 8.69528 11.0152 8.76561C10.9448 8.83594 10.8495 8.87545 10.75 8.87545C10.6505 8.87545 10.5552 8.83594 10.4848 8.76561C10.4145 8.69528 10.375 8.5999 10.375 8.50045C10.375 8.40099 10.4145 8.30561 10.4848 8.23528C10.5552 8.16495 10.6505 8.12545 10.75 8.12545C10.8495 8.12545 10.9448 8.16495 11.0152 8.23528C11.0855 8.30561 11.125 8.40099 11.125 8.50045Z" />
  </svg>
);

export const investmentTrendsSvg = (
  <svg width="20" height="21" viewBox="0 0 20 21" stroke="currentColor">
    <path d="M17.5 1.5H2.5C2.10218 1.5 1.72064 1.65804 1.43934 1.93934C1.15804 2.22064 1 2.60218 1 3V18C1 18.3978 1.15804 18.7794 1.43934 19.0607C1.72064 19.342 2.10218 19.5 2.5 19.5H17.5C17.8978 19.5 18.2794 19.342 18.5607 19.0607C18.842 18.7794 19 18.3978 19 18V3C19 2.60218 18.842 2.22064 18.5607 1.93934C18.2794 1.65804 17.8978 1.5 17.5 1.5Z" />
    <path
      d="M4.71875 13.4175L7.54725 10.589L9.74125 12.7775L14.9988 7.5"
      stroke="#F3F3F3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 7.5H15V11.5"
      stroke="#F3F3F3"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const investorsSvg = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    stroke="currentColor"
    fill="currentColor"
  >
    <g clipPath="url(#clip0_601_1782)">
      <path d="M7.40126 11.7593L7.41029 11.7596H7.41932H7.68434C7.88286 12.1414 8.13045 12.4947 8.42023 12.8107C7.46436 13.2165 6.59596 13.8094 5.8677 14.5575L5.85716 14.5684L5.84729 14.5798L5.68293 14.7705L5.31862 15.1812L5.19266 15.3232V15.513V18.1463H3.47266V13.3113L3.49913 13.2804C4.00906 12.7764 4.61632 12.3816 5.28394 12.1199C5.95755 11.8559 6.67824 11.7332 7.40126 11.7593Z" />
      <path d="M16.6095 11.7401L16.6172 11.7401L16.6249 11.7398C17.348 11.7136 18.0686 11.8364 18.7423 12.1004C19.4049 12.3601 20.0081 12.751 20.5157 13.2496L20.5335 13.2734V18.1534H18.9069V15.5134V15.3262L18.7839 15.185L18.4239 14.7717L18.4239 14.7717L18.4198 14.7671L18.2532 14.5804L18.2481 14.5747L18.2428 14.5691C17.4734 13.759 16.5409 13.127 15.5108 12.7125C15.7774 12.4226 16.0086 12.1011 16.1989 11.7546C16.3356 11.7457 16.4725 11.7408 16.6095 11.7401Z" />
      <path d="M8.94771 5.66045C8.37054 6.10524 7.90012 6.67729 7.57493 7.33499C7.24715 7.99793 7.0781 8.72528 7.07771 9.45987H7.05496C6.79026 9.41853 6.53423 9.32961 6.29958 9.19645L6.05281 9.63131L6.29958 9.19645C5.9642 9.00613 5.68399 8.73196 5.48639 8.40081C5.2888 8.06965 5.1806 7.69285 5.17238 7.30732C5.16416 6.92178 5.25621 6.54071 5.43952 6.20144C5.62282 5.86217 5.8911 5.57631 6.21807 5.37187C6.54504 5.16743 6.91951 5.05141 7.30479 5.03518C7.69008 5.01894 8.07297 5.10304 8.41599 5.27925L8.57795 4.96396L8.41599 5.27925C8.61183 5.37986 8.79084 5.50852 8.94771 5.66045Z" />
      <path d="M17.8526 9.10711C17.5324 9.31164 17.1652 9.43079 16.7861 9.45332C16.786 9.45109 16.7859 9.44886 16.7858 9.44663C16.7805 8.64715 16.5778 7.86128 16.1957 7.15891C15.8961 6.60837 15.4936 6.12255 15.0116 5.727C15.1676 5.55662 15.3498 5.41086 15.5521 5.29564C15.8862 5.10538 16.2639 5.00488 16.6484 5.00391C17.0329 5.00295 17.411 5.10155 17.7461 5.29012C18.0811 5.47869 18.3617 5.75081 18.5603 6.07998C18.759 6.40914 18.8691 6.78414 18.8798 7.16847C18.8905 7.5528 18.8015 7.93335 18.6215 8.27308C18.4415 8.61282 18.1766 8.90015 17.8526 9.10711Z" />
      <path d="M14.1436 9.46633C14.1436 10.6979 13.1452 11.6963 11.9136 11.6963C10.682 11.6963 9.68359 10.6979 9.68359 9.46633C9.68359 8.23473 10.682 7.23633 11.9136 7.23633C13.1452 7.23633 14.1436 8.23473 14.1436 9.46633Z" />
      <path d="M12.0408 14.7827L12.072 14.784L12.1032 14.7826C12.87 14.7494 13.6356 14.8732 14.3529 15.1464C15.0412 15.4085 15.6712 15.8028 16.2074 16.3069V20.2307C16.2061 20.268 16.1977 20.3047 16.1828 20.3389C16.1672 20.3746 16.1447 20.4069 16.1166 20.4339C16.0886 20.461 16.0554 20.4822 16.0192 20.4964C15.9829 20.5106 15.9442 20.5175 15.9052 20.5168L15.898 20.5167H15.8907H8.23073H8.2235L8.21626 20.5168C8.1773 20.5175 8.13857 20.5106 8.10229 20.4964C8.06601 20.4822 8.03289 20.4609 8.00481 20.4339C7.97674 20.4069 7.95426 20.3746 7.93867 20.3389C7.92373 20.3047 7.91539 20.268 7.91406 20.2307V16.3138C8.45565 15.8088 9.09042 15.4136 9.78322 15.1505C10.5033 14.8771 11.2712 14.752 12.0408 14.7827Z" />
    </g>
    <defs>
      <clipPath id="clip0_601_1782">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const unicornsSvg = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    stroke="currentColor"
    fill="currentColor"
  >
    <g clipPath="url(#clip0_601_1795)">
      <path d="M13.6396 6.79565L17.7797 2.89147L16.9024 6.04923L16.6382 7H17.625H19.5986L18.5985 8.50023L18.1428 9.18373L18.8648 9.57547C19.6956 10.0262 20.25 10.8842 20.25 11.875V19.2094L17.9409 19.9791L14.881 15.2159L14.8811 15.2159L14.8762 15.2085C14.4926 14.6265 13.823 14.5164 13.3211 14.6981C12.8138 14.8817 12.3713 15.4035 12.4718 16.1048L13.3312 22.9521L3.83905 18.206L4.81777 12.8537L4.81811 12.8517C5.42869 9.46307 8.37999 7 11.82 7H13.125H13.4229L13.6396 6.79565Z" />
    </g>
    <defs>
      <clipPath id="clip0_601_1795">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const peopleSvg = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    stroke="currentColor"
    fill="currentColor"
  >
    <path d="M18.0939 8.32098L18.0939 8.32111C17.9775 9.93679 16.8028 11 15.7482 11C14.6928 11 13.5168 9.9365 13.4025 8.32204L13.4025 8.32195C13.3458 7.52168 13.5945 6.88815 13.999 6.45683C14.4054 6.02348 15.0105 5.75 15.7482 5.75C17.1707 5.75 18.2031 6.80848 18.0939 8.32098Z" />
    <path d="M15.7498 15.5C18.5575 15.5 21.0277 16.8102 21.7107 19.25H9.79017C10.4754 16.8494 12.9514 15.5 15.7498 15.5Z" />
    <path d="M6.89058 11.1875C7.63116 11.1875 8.53784 10.3982 8.6269 9.16204C8.7078 8.03928 7.93697 7.25 6.89058 7.25C5.83928 7.25 5.07319 8.01536 5.15434 9.16298L6.89058 11.1875ZM6.89058 11.1875C6.14926 11.1875 5.24178 10.3979 5.15434 9.16302L6.89058 11.1875Z" />
    <mask id="path-4-inside-1_601_1801">
      <path d="M9.65671 14.8434C8.81061 14.4557 7.87874 14.3066 6.89108 14.3066C4.45358 14.3066 2.10515 15.5184 1.51686 17.8785C1.43952 18.1907 1.63546 18.4996 1.95608 18.4996H7.21921" />
    </mask>
    <path d="M1.51686 17.8785L0.0613948 17.5157L0.0608827 17.5178L1.51686 17.8785ZM10.2815 13.4797C9.1851 12.9773 8.02543 12.8066 6.89108 12.8066V15.8066C7.73205 15.8066 8.43612 15.9341 9.03191 16.207L10.2815 13.4797ZM6.89108 12.8066C4.05935 12.8066 0.878189 14.2388 0.0613962 17.5157L2.97233 18.2413C3.3321 16.7979 4.84781 15.8066 6.89108 15.8066V12.8066ZM0.0608827 17.5178C-0.199023 18.5669 0.456183 19.9996 1.95608 19.9996V16.9996C2.31844 16.9996 2.64144 17.19 2.82592 17.4602C2.99763 17.7116 3.03257 17.9982 2.97285 18.2392L0.0608827 17.5178ZM1.95608 19.9996H7.21921V16.9996H1.95608V19.9996Z" />
  </svg>
);

export const profileSvg = (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    stroke="currentColor"
    fill="currentColor"
  >
    <path d="M8.75 7.5C8.75 6.63805 9.09241 5.8114 9.7019 5.2019C10.3114 4.59241 11.138 4.25 12 4.25C12.862 4.25 13.6886 4.59241 14.2981 5.2019C14.9076 5.8114 15.25 6.63805 15.25 7.5C15.25 8.36195 14.9076 9.1886 14.2981 9.7981C13.6886 10.4076 12.862 10.75 12 10.75C11.138 10.75 10.3114 10.4076 9.7019 9.7981C9.09241 9.1886 8.75 8.36195 8.75 7.5ZM4.9948 15.4948C5.79183 14.6978 6.87283 14.25 8 14.25H16C17.1272 14.25 18.2082 14.6978 19.0052 15.4948C19.8022 16.2918 20.25 17.3728 20.25 18.5C20.25 19.0967 20.0129 19.669 19.591 20.091C19.169 20.5129 18.5967 20.75 18 20.75H6C5.40326 20.75 4.83097 20.5129 4.40901 20.091C3.98705 19.669 3.75 19.0967 3.75 18.5C3.75 17.3728 4.19777 16.2918 4.9948 15.4948Z" />
  </svg>
);
